import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

const columns = [
    {
        label: "Código Solicitud",
        field: "id",
        sort: "asc"
    },
    {
        label: "Nombre",
        field: "titulo",
        sort: "asc"
    },
    {
        label: "Fecha de Solicitud",
        field: "fecha_creacion_str",
        sort: "asc"
    },
    {
        label: "Prioridad",
        field: "prioridad_nombre",
        sort: "asc"
    },
    /*  
        label: "Tipo Solicitud",
        field: "tipo_solicitud_nombre",
        sort: "asc"
    } */
    {
        label: "Fecha Programada",
        field: "fecha_programada_str",
        sort: "asc"
    },
    {
        label: "Asignado a",
        field: "colaborador_nombre",
        sort: "asc"
    },
    {
        label: "Ubicación",
        field: "lugar_ubicacion_nombre",
        sort: "asc"
    },
    {
        label: "Departamento / Área",
        field: "asignado_a_nombre",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estado_nombre",
        sort: "asc"
    },
    {
        label: "Acciones",
        field: "accion",
        width: 100
    }
];
export default class SolicitudConcluirMasivo extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.solicitud = 'CONCLUIR_MASIVO';
        this.titulo = 'Solicitudes Concluir Masivo';
        this.hoy = new Date()       
        this.fechaToday = this.formatoFecha(this.hoy)
        this.fechaAtras = this.formatoFecha(new Date(this.hoy.getFullYear(), this.hoy.getMonth(), this.hoy.getDate() - 7))

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            mostrarSpinner: true,
            ubicaciones: [],
            departamentosAreas: [],
            tiposSolicitudes: [],
            solicitudesConcluidas: [],

            filtros: {
                fechaMin: this.fechaAtras,
                fechaFin: this.fechaToday,
                lugar_ubicacion: undefined,
                solicitar_a: undefined,
                tipo_solicitud: undefined,
                usuario: undefined,
                empresa: undefined,
                solicitud_id: undefined,
                estado: undefined,
                fechaProgramadaMin: undefined,
                fechaProgramadaFin: undefined,
            }
        }
    }

    componentDidMount() {
        this.cargarValoresFiltros();        
        if (this.apiRest.getRol() || this.apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO')) {            
            this.setState({ mostrarSpinner: false});
            toastr.warning('Ingrese los valores de búsqueda');
        } else {
            this.revisarMisSolicitudes();            
        }
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoDepartamento = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoDepartamento2 = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoSelectUbicacion = valores => valores.data.map(i => ({ value: i.id, label: i.ubicacion_texto }));
    formatoSolicitud = valores => valores.data.map(i => ({ value: i.id, label: i.id + '->' + i.titulo }));

    cargarValoresFiltros = () => {
        this.apiRest.get('/colaboradorDepartamentoAreaAsociados').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: resultado.data });
            }
        });        
        this.apiRest.get('/ubicacion').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ ubicaciones: this.formatoSelectUbicacion(resultado) });
            }
        });
    }

    obtenerTipoSolicitud(departamentoArea) {
        if (departamentoArea) {
            this.apiRest.get('/tipoSolicitudPorDepartamentoArea/' + departamentoArea.value).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tiposSolicitudes: this.formatoSelect(resultado) });
                }
            });
        } else {
            this.setState({ tiposSolicitudes: [] });
        }
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, [name]: value }
        }));
    }

    setDepartamentoArea = departamentoArea => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['solicitar_a']: departamentoArea }
        }));

        this.obtenerTipoSolicitud(departamentoArea);
    }

    setTipoSolicitud = tipoSolicitud => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['tipo_solicitud']: tipoSolicitud }
        }));
    }

    setUbicacion = ubicacion => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['lugar_ubicacion']: ubicacion }
        }));
    }

    botonesListado = (registro, indicador) => {
        return (
            <Input
                key={registro.id}
                type="checkbox"
                value={registro.id}
                onChange={this.handleChange}
                className="form-control"
                defaultChecked={this.state.solicitudesConcluidas.some(item => item.codigo_solicitud === registro.id)}
            />
        )
    }

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => [
            registro.titulo = (registro.titulo != "") ? registro.titulo : registro.descripcion.substring(0, 35), 
            registro.accion = this.botonesListado(registro)
        ]);
        return { columns, rows };
    };

    mostrarModalConcluirTodos = () => {
        if(this.state.tabla.rows.length > 0){
            this.setState({ modalAbierto: true });
        } else {
            toastr.error('El listado de solicitudes esta vacio. Favor de realizar una búsqueda.');
        }
    }

    ocultarModalConcluirTodos = () => {
        this.setState({ modalAbierto: false });
    }

    buscar = () => {
        const {
            filtros
        } = this.state

        filtros.solicitud = this.solicitud;
        this.setState({ mostrarSpinner: true });
        
        this.apiRest.post('/solicitudesFiltradas', filtros).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data) });
                this.obtenerTipoSolicitud(this.state.filtros.solicitar_a);
                this.setState({ mostrarSpinner: false }); 
            }
        });
    }

    validarFiltros = () => {
        const {
            filtros
        } = this.state

        if (_valid(filtros.fechaMin)) {
            if (_valid(filtros.fechaMin) && _valid(filtros.fechaFin)) {
                return true
            } else {
                toastr.error('Fecha no valida falta seleccionar Fecha Fin.');
                return false
            }
        }

        if (_valid(filtros.fechaFin)) {
            if (_valid(filtros.fechaMin) && _valid(filtros.fechaFin)) {
                return true
            } else {
                toastr.error('Fecha no valida falta seleccionar Fecha Inicio.');
                return false
            }
        }

        if (_valid(filtros.fechaProgramadaMin)) {
            if (_valid(filtros.fechaProgramadaMin) && _valid(filtros.fechaProgramadaFin)) {
                return true
            } else {
                toastr.error('Fecha no valida falta seleccionar Fecha Programada Fin.');
                return false
            }
        }

        if (_valid(filtros.fechaProgramadaFin)) {
            if (_valid(filtros.fechaProgramadaMin) && _valid(filtros.fechaProgramadaFin)) {
                return true
            } else {
                toastr.error('Fecha no valida falta seleccionar Fecha Programada Inicio.');
                return false
            }
        }

        return true;
    }    

    filtrarBusqueda = () => {
        const { filtros } = this.state
        filtros.solicitud = this.solicitud;
        
        if (this.validarFiltros()) {            
            if (this.apiRest.getRol() || this.apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO')) {
                this.buscar();
            } else {
                this.revisarMisSolicitudes();            
            }            
        }
    }

    concluirMasivo = () => {
        const {
            solicitudesConcluidas
        } = this.state

        if (solicitudesConcluidas.length > 0){
            this.setState({ mostrarSpinner: true });
        
            this.apiRest.post('/solicitudConcluirMasivo', solicitudesConcluidas).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ mostrarSpinner: false }); 
                    toastr.success('Se concluyeron las solicitudes!');
                    this.filtrarBusqueda();
                }
            });
        } else {
            toastr.error('No ha seleccionado solicitudes');
        }        
        
    }

    handleChange = ({ target: { value, checked } }) => {
        this.setState(estadoAnterior => {
            const solicitudesConcluidas = [...estadoAnterior.solicitudesConcluidas];
            if (checked) {
                // Agregar el elemento a la lista
                solicitudesConcluidas.push({ codigo_solicitud: value, concluido: 1 });
            } else {
                // Eliminar el elemento de la lista
                const index = solicitudesConcluidas.findIndex(item => item.codigo_solicitud === value);
                if (index !== -1) {
                    solicitudesConcluidas.splice(index, 1);
                }
            }
            return { solicitudesConcluidas };
        });
    };     
    
    marcarTodos = () => {        
        if(this.state.tabla.rows.length > 0){
            this.setState(estadoAnterior => {
                const solicitudesConcluidas = [];    
                estadoAnterior.tabla.rows.map(registro => { 
                    solicitudesConcluidas.push({ codigo_solicitud: registro.id.toString(), concluido: 1 })
                }); 
                return { solicitudesConcluidas };
            }, this.concluirMasivo);
        } else {
            toastr.error('El listado de solicitudes esta vacio. Favor de realizar una búsqueda.');
        }        
    }; 

    revisarMisSolicitudes = () => {
        const {
            filtros
        } = this.state

        filtros.solicitud = this.solicitud;
        filtros.usuario = this.apiRest.getLS('du').colaborador.id;
        this.setState({ mostrarSpinner: true });       
        this.apiRest.put('/misSolicitudes', filtros).then(respuesta => {
            if (respuesta.exitoso) {                
                this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data) });
                this.setState({ mostrarSpinner: false });
            }
        });
    }

    limpiarCampo = (name) => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, [name]: null }
        }));
    }

    limpiar = () => {          
        this.setState({
            filtros: {
                fechaMin: '',
                fechaFin: '',
                lugar_ubicacion: '',
                solicitar_a: '',
                tipo_solicitud: '',                
                solicitud_id: '',
                estado: '',
                fechaProgramadaMin: '',
                fechaProgramadaFin: '',
            },
            tabla: { columns: columns, rows: [] },
        });
    }

    formatoFecha(fecha) {
        let dia = fecha.getDate();
        let mes = fecha.getMonth() + 1;
        let anio = fecha.getFullYear();
        if (dia < 10) {
            dia = '0' + dia;
        }
        if (mes < 10) {
            mes = '0' + mes;
        }
        return anio + '-' + mes + '-' + dia;
    }

    render() {
        const {
            mostrarSpinner,
            tabla,
            modalAbierto,
            filtros,
            ubicaciones,
            departamentosAreas,
            tiposSolicitudes
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem={this.titulo} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <div>
                                            <Row>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaInicio" className="form-label">
                                                        Fecha Inicio
                                                    </Label>
                                                    <Input
                                                        name="fechaMin"
                                                        value={filtros.fechaMin}
                                                        onChange={this.actualizarValores}
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaFin" className="form-label">
                                                        Fecha Fin
                                                    </Label>
                                                    <Input
                                                        name="fechaFin"
                                                        value={filtros.fechaFin}
                                                        onChange={this.actualizarValores}
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="solicitar_a" className="form-label">
                                                        Departamento / Área
                                                    </Label>
                                                    <Select
                                                        name="solicitar_a"
                                                        options={departamentosAreas}
                                                        value={filtros.solicitar_a}
                                                        onChange={this.setDepartamentoArea}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Seleccionar"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="tipo_solicitud" className="form-label">
                                                        Tipo de solicitud
                                                    </Label>
                                                    <Select
                                                        name="tipo_solicitud"
                                                        options={tiposSolicitudes}
                                                        value={filtros.tipo_solicitud}
                                                        onChange={this.setTipoSolicitud}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Seleccionar"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "Debe seleccionar un Departamento u Área para mostrar los tipo de solicitudes"}
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={3}>
                                                    <Label htmlFor="lugar_ubicacion" className="form-label">
                                                        Ubicaci&oacute;n
                                                    </Label>
                                                    <Select
                                                        name="lugar_ubicacion"
                                                        options={ubicaciones}
                                                        value={filtros.lugar_ubicacion}
                                                        onChange={this.setUbicacion}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Seleccionar"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                                <Col lg={3}></Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaInicio" className="form-label">
                                                        Fecha Programada Inicio
                                                    </Label>
                                                    <Input
                                                        name="fechaProgramadaMin"
                                                        value={filtros.fechaProgramadaMin}
                                                        onChange={this.actualizarValores}
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaFin" className="form-label">
                                                        Fecha Programada Fin
                                                    </Label>
                                                    <Input
                                                        name="fechaProgramadaFin"
                                                        value={filtros.fechaProgramadaFin}
                                                        onChange={this.actualizarValores}
                                                        type="date"
                                                    />
                                                </Col>
                                            </Row>
                                            <p />    
                                            <Row>
                                                <Col lg={12}>
                                                    <MDBBtn className="waves-effect" color="info" onClick={this.filtrarBusqueda}>
                                                        <MDBIcon icon="fas fa-search" />{' '}
                                                        BUSCAR
                                                    </MDBBtn>                                                    
                                                    <MDBBtn className="waves-effect float-end" color="danger" onClick={this.limpiar}>
                                                        Borrar Filtros
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={12}>
                                                    <MDBBtn className="waves-effect float-end" color="primary" onClick={this.mostrarModalConcluirTodos}>
                                                        CONCLUIR TODOS
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={12}>
                                                    <MDBBtn className="waves-effect float-end" color="success" onClick={this.concluirMasivo}>
                                                        <MDBIcon icon="fa fa-check-square" />{' '}
                                                        Concluir Seleccionados
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </div>
                                            
                                        <p />
                                        {
                                            mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive">
                                            <MDBDataTable
                                                keyField="id"
                                                hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]}
                                                noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]}
                                                entriesLabel="Mostrando entradas" data={tabla}
                                                disableRetreatAfterSorting={true}
                                                searching={false}
                                                paging={false}
                                            />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={modalAbierto} size="mm">
                    <ModalHeader>
                        Concluir todos los ticket
                    </ModalHeader>
                    <ModalBody>
                        Esta segur@?
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="danger" onClick={() => this.marcarTodos()}>
                            <MDBIcon icon="fa fa-th-list" /> {' '}
                            CONCLUIR TODOS
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalConcluirTodos()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}